(() => {
  const pageSelector = '.trots-info--wederverkoper-worden';
  const formSelector = '.trots-info__dynamic--reseller';
  const successSelector = '[data-reseller-success]';
  const fullFormMinimumHeight = 700;
  const successMaximumHeight = 520;

  const normalizeText = (value) =>
    typeof value === 'string' ? value.replace(/\s+/g, ' ').trim().toLocaleLowerCase('nl-NL') : '';

  const containsSuccessMessage = (formArea) => {
    const text = normalizeText(formArea.textContent);
    const hasConfirmationTitle = text.includes('aanvraag ontvangen');
    const hasConfirmationCopy =
      text.includes('bedankt voor uw aanvraag') ||
      text.includes('bedankt voor je aanvraag') ||
      text.includes('wederverkopersaccount is aangevraagd');

    return hasConfirmationTitle && hasConfirmationCopy;
  };

  const initResellerSuccess = (page) => {
    const formArea = page.querySelector(formSelector);
    const success = page.querySelector(successSelector);
    const formCard = page.querySelector('.trots-info__form-card--native');

    if (!formArea || !success || !formCard) return;

    let largestFormHeight = 0;
    let resizeTimer;
    let mutationObserver;
    let resizeObserver;

    const stopObservers = () => {
      mutationObserver?.disconnect();
      resizeObserver?.disconnect();
      window.clearTimeout(resizeTimer);
    };

    const showConfirmation = (confirmedBySize = false) => {
      if (page.classList.contains('is-reseller-confirmed')) return false;
      if (!confirmedBySize && !containsSuccessMessage(formArea)) return false;

      page.classList.add('is-reseller-confirmed');
      success.hidden = false;
      formCard.setAttribute('aria-label', 'Aanvraag ontvangen');
      stopObservers();

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          formCard.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start',
          });
        });
      });

      return true;
    };

    const hasCollapsedToConfirmation = () => {
      const currentHeight = formArea.getBoundingClientRect().height;

      if (currentHeight >= fullFormMinimumHeight) {
        largestFormHeight = Math.max(largestFormHeight, currentHeight);
        return false;
      }

      return (
        largestFormHeight >= fullFormMinimumHeight &&
        currentHeight > 0 &&
        currentHeight <= successMaximumHeight &&
        currentHeight <= largestFormHeight * 0.6
      );
    };

    if (showConfirmation()) return;

    mutationObserver = new MutationObserver(() => {
      showConfirmation();
    });

    mutationObserver.observe(formArea, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(() => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          if (hasCollapsedToConfirmation()) showConfirmation(true);
        }, 120);
      });

      resizeObserver.observe(formArea);
      hasCollapsedToConfirmation();
    }
  };

  const init = () => {
    document.querySelectorAll(pageSelector).forEach(initResellerSuccess);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
